import { render, staticRenderFns } from "./ProductDetailsPage.vue?vue&type=template&id=7449ec3e&scoped=true&"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsPage.vue?vue&type=style&index=0&id=7449ec3e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7449ec3e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadCrumbs: require('/var/www/fs-store/components/BreadCrumbs.vue').default,SlideShow: require('/var/www/fs-store/components/SlideShow.vue').default,ShareButtons: require('/var/www/fs-store/components/ShareButtons.vue').default,AttributesCheckbox: require('/var/www/fs-store/components/AttributesCheckbox.vue').default,ProductsCard: require('/var/www/fs-store/components/ProductsCard.vue').default,ModalProducts: require('/var/www/fs-store/components/ModalProducts.vue').default})
